import { Button } from "@chakra-ui/react";
import React, { useCallback } from "react";
import { useFormContext, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FormSubmitButton } from "shared/components/button/FormSubmitButton";
import {
  FormFooter,
  FormFooterActions,
  FormFooterBreadcrumb,
} from "shared/components/form/FormFooter";
import {
  PageWizardBar,
  usePageWizard,
} from "shared/components/layout/PageWizard";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export interface CreditFacilitySetupFooterProps {
  submitText?: string;
  onClickContinue?: () => void;
}

export const CreditFacilitySetupFooter: React.FC<
  CreditFacilitySetupFooterProps
> = ({ submitText, onClickContinue }) => {
  const { t } = useTranslation(["common"]);
  const navigate = useNavigate();

  const { fundFamilyId, creditFacilityId } = useRequiredStringParams();
  const { currentIndex, navigateBack } = usePageWizard();
  const hasForm = !!(useFormContext() as UseFormReturn | null);
  const ContinueButton =
    !onClickContinue && hasForm ? FormSubmitButton : Button;

  const exitToDraft = useCallback(() => {
    navigate(
      rootRoute({})
        .fundFamilies({})
        .fundFamily({ fundFamilyId })
        .setup({})
        .creditFacilities({})
        .creditFacility({ creditFacilityId }).$,
    );
  }, [navigate, fundFamilyId, creditFacilityId]);

  return (
    <FormFooter>
      <FormFooterBreadcrumb>
        <PageWizardBar />
      </FormFooterBreadcrumb>
      <FormFooterActions>
        <Button colorScheme="secondary" onClick={exitToDraft}>
          {t("common:exit")}
        </Button>
        {currentIndex > 0 && (
          <Button colorScheme="secondary" onClick={navigateBack}>
            {t("common:back")}
          </Button>
        )}
        <ContinueButton onClick={onClickContinue}>
          {submitText ?? t("common:continue")}
        </ContinueButton>
      </FormFooterActions>
    </FormFooter>
  );
};
